import { getDateObj as c } from "../../../../helpers/formatting/formatDate.js";
const g = ({
  email: n,
  minDate: t,
  maxDate: r,
  validate: a,
  ...i
}) => {
  if (a && typeof a != "object" && (n || t || r))
    throw new Error(
      "IressForm: To use custom IDS rules, the validate prop must be an object."
    );
  const f = a ?? {};
  if (n && (f.email = (e) => {
    if (!e)
      return !0;
    const o = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/, s = typeof n == "string" ? n : !1;
    return o.test(e) || s;
  }), t) {
    const e = "value" in t ? t.value : t, o = "message" in t ? t.message : !1;
    f.minDate = (s) => s ? c(s) >= e || o : !0;
  }
  if (r) {
    const e = "value" in r ? r.value : r, o = "message" in r ? r.message : !1;
    f.maxDate = (s) => s ? c(s) <= e || o : !0;
  }
  return {
    ...i,
    validate: f
  };
};
export {
  g as transformCustomRulesToValidateRule
};
